import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import moment from 'moment';
import PropTypes from 'prop-types';

import { Main, Filter } from 'Containers';
import { LoadingPage, DirtyWrapper } from 'Components';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { submitForm, resetForm, destroyForm } from 'State/forms/actions';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { BidGroupEnum, AdjustmentEnum, FilterEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { CREATE_EDIT_ADJUSTMENT_FORM_NAME } from 'Common/FormEnum';
import { NewEditAdjustmentEnum } from 'Common/Constants/Enumeration/AdjustmentListEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
} from 'State/filters/actions';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import * as FilterSelectors from 'State/filters/selectors';

import {
  clearInvalidPreviewData,
  clearOrderSubmitError,
  emptyItemList,
  getAdjustmentDetail,
  getAdjustmentItems,
  resetFilterOnClickOfPreviousPage,
  saveAdjustment,
  emptyEditDulObject,
} from '../../state/createEditAdjustment/actions';
import { CreateEditAdjustment } from '../../containers/createEditAdjustment/CreateEditAdjustmentContainer';
import { PreviewAdjustment } from '../createEditAdjustment/PreviewAdjustment';
import { getSaveObject, basicURL } from './../../helper';
import * as CreateEditSelectors from '../../state/createEditAdjustment/selectors';
import * as AdjustmentSelectors from '../../state/adjustmentList/selectors';

class CreateEditAdjustmentWizardForm extends Component {
  static propTypes = {
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getAdjustmentItems: PropTypes.func.isRequired,
    clearOrderSubmitError: PropTypes.func.isRequired,
    clearInvalidPreviewData: PropTypes.func.isRequired,
    resetFilterOnClickOfPreviousPage: PropTypes.func.isRequired,
    saveAdjustment: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    destroyForm: PropTypes.func.isRequired,
    getAdjustmentDetail: PropTypes.func.isRequired,
    emptyItemList: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    emptyEditDulObject: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    adjustmentItemsInfo: PropTypes.array,
    allTableStates: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool,
    fetchingSites: PropTypes.bool.isRequired,
    fetchingAdjustmentItems: PropTypes.bool.isRequired,
    adjustmentItemsLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    loading: PropTypes.bool.isRequired,
    fetchingDropDown: PropTypes.bool.isRequired,
    fetchingAdjustmentDetail: PropTypes.bool.isRequired,
    selectedAdjustmentDetail: PropTypes.object,
    fetchAdjustmentDetailError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    Site: PropTypes.string,
    adjustmentDT: PropTypes.string,
  };
  static defaultProps = {
    Site: GenericEnum.EmptyString,
    adjustmentDT: moment().format(DATE_FORMAT_FOR_UI),
    adjustmentItemsInfo: [],
    adjustmentItemsLoadingError: null,
    selectedAdjustmentDetail: null,
    fetchAdjustmentDetailError: null,
    bidGroupDataError: null,
    itemGroupDataError: null,
    isDisabled: false,
  };
  static path = '/adjustment/:IsNewEdit/:TransactionId';

  state = {
    page: 1,
    message: '',
    showNotificationModal: false,
    isPreferenceDataChange: false,
    showDateModal: false,
    resetPageOnDataChange: true,
  };

  componentDidMount() {
    const { IsNewEdit, TransactionId } = this.props.match.params;
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getAdjustmentDetail,
    } = this.props;

    getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    getItemGroupForCurrentSite();
    if (IsNewEdit !== NewEditAdjustmentEnum.NEW) {
      getAdjustmentDetail(TransactionId);
    }
    this.props.resetDirty();
  }

  componentDidUpdate(prevProps) {
    const { clearOrderSubmitError } = this.props;

    if (
      errorToast(this.props, prevProps, 'adjustmentItemsLoadingError') ||
      errorToast(this.props, prevProps, 'fetchAdjustmentDetailError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'submitError')
    ) {
      clearOrderSubmitError();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Adjustment has been saved',
        true
      );
      clearOrderSubmitError();
    }
  }

  componentWillUnmount() {
    const { emptyItemList, emptyEditDulObject } = this.props;
    this.completeReset();
    emptyEditDulObject();
    emptyItemList();
    this.clearTableSavedState();
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.ADJUSTMENT_LIST_TABLE,
      TableNamesEnum.ADJUSTMENT_LIST_CREATE_EDIT_TABLE,
    ]);
  };

  completeReset = () => {
    this.props.resetForm(CREATE_EDIT_ADJUSTMENT_FORM_NAME);
    this.props.destroyForm(CREATE_EDIT_ADJUSTMENT_FORM_NAME);
  };

  hideNotificationModal = () => {
    this.setState({ showNotificationModal: false });
  };

  getRootUrl = () => {
    return '/adjustment';
  };

  onPreviewAdjustmentItemsClick = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, '', allTableStates, setTableStates, [
      TableNamesEnum.ADJUSTMENT_LIST_CREATE_EDIT_TABLE,
    ]);
    this.setState({
      page: this.state.page + 1,
      resetPageOnDataChange: true,
    });
  };

  previousPage = () => {
    const {
      adjustmentItemsInfo,
      clearInvalidPreviewData,
      resetFilterOnClickOfPreviousPage,
    } = this.props;
    const data = adjustmentItemsInfo.filter(item => {
      return item.PriQtyAdj || item.SecQtyAdj;
    });
    clearInvalidPreviewData(data);
    this.setState({ page: this.state.page - 1, resetPageOnDataChange: true });
    resetFilterOnClickOfPreviousPage();
  };

  handleSave = () => {
    const adjustmentDT = moment(this.props.adjustmentDT);
    const currentDate = moment();
    if (adjustmentDT > currentDate) {
      this.setState({
        showDateModal: true,
      });
    } else {
      this.props.submitForm(CREATE_EDIT_ADJUSTMENT_FORM_NAME);
    }
  };

  handleDateChange = result => {
    this.setState({
      showDateModal: false,
    });
    if (result) {
      this.props.submitForm(CREATE_EDIT_ADJUSTMENT_FORM_NAME);
    }
  };

  resetScroll = () => this.props.scrollMainTo(0, 0);

  handleSubmit = values => {
    const { IsNewEdit, TransactionId } = this.props.match.params;
    let TransactionID =
      IsNewEdit !== NewEditAdjustmentEnum.VIEW
        ? NewEditAdjustmentEnum.NEW
        : TransactionId;
    this.props.saveAdjustment(
      getSaveObject(values, TransactionID, IsNewEdit),
      this.resetScroll
    );
  };

  getMainProps = showDirtyConfirm => {
    const { page } = this.state;
    const { Site, adjustmentDT, adjustmentItemsInfo, isDisabled } = this.props;
    let toolbox = {
      backButtonProps: { shown: true, path: this.getRootUrl() },
      rightButtons: [],
      shown: true,
    };
    !isDisabled &&
      (toolbox.rightButtons = [
        {
          content: 'Preview Adjustment Items',
          onClick: this.onPreviewAdjustmentItemsClick,
          disabled:
            Site === NewEditAdjustmentEnum.NEW ||
            !adjustmentDT ||
            (!adjustmentItemsInfo || !adjustmentItemsInfo.length),
        },
      ]);
    if (page === 2) {
      delete toolbox.backButtonProps;
      toolbox.rightButtons = [
        {
          content: 'Previous Page',
          onClick: this.previousPage,
        },
        {
          content: 'Save Update On Hand and Close',
          onClick: this.handleSave,
          disabled: !this.isPreviewContainsValidData(),
        },
        {
          content: 'Cancel',
          onClick: showDirtyConfirm,
        },
      ];
    }
    return {
      toolbox,
    };
  };

  getBreadCrumbs = () => {
    const { page } = this.state;
    const { IsNewEdit } = this.props.match.params;
    let breadcrumbs = [
      {
        title: 'Adjustment',
        link: '/adjustment',
      },
      {
        title: IsNewEdit !== NewEditAdjustmentEnum.VIEW ? 'Create New' : 'View',
        link: '',
      },
    ];
    if (page === 1) {
      breadcrumbs[1].link = '';
    }
    if (page === 2) {
      breadcrumbs.push({
        title: 'Adjustment Items',
        link: '',
      });
    }
    return breadcrumbs;
  };

  onCancelClick = () => {
    this.props.history.push('/adjustment');
  };

  isPreviewContainsValidData = () => {
    const { adjustmentItemsInfo } = this.props;
    let data = [];
    if (adjustmentItemsInfo && adjustmentItemsInfo.length) {
      data = adjustmentItemsInfo.filter(item => {
        return item.PriQtyAdj || item.SecQtyAdj;
      });
    }
    return Boolean(data.length);
  };

  getCreatePageAndPreviewPage = () => {
    const { page, message, showNotificationModal } = this.state;
    const { IsNewEdit, TransactionId } = this.props.match.params;
    const {
      isDisabled,
      fetchingAdjustmentItems,
      selectedAdjustmentDetail,
      adjustmentItemsInfo,
      fetchAdjustmentDetailError,
    } = this.props;
    let element = [];
    let render = false;
    let initialValues = {};
    if (IsNewEdit !== NewEditAdjustmentEnum.NEW) {
      if (selectedAdjustmentDetail) {
        render = true;
        initialValues = {
          [FilterEnum.GroupId_Bid]: 0,
          [FilterEnum.GroupId_Item]: 0,
          [AdjustmentEnum.Site]:
            selectedAdjustmentDetail[AdjustmentEnum.SiteId],
          [AdjustmentEnum.AdjustmentItemsInfo]: [],
          [AdjustmentEnum.TransactionDT]: moment(
            selectedAdjustmentDetail[AdjustmentEnum.TransactionDT]
          ).format(DATE_FORMAT_FOR_UI),
          [AdjustmentEnum.Comments]:
            selectedAdjustmentDetail[AdjustmentEnum.Comments],
          [AdjustmentEnum.TransactionId]: TransactionId,
        };
      } else if (fetchAdjustmentDetailError) {
        render = true;
        initialValues = {
          [AdjustmentEnum.Site]: GenericEnum.EmptyString,
          [AdjustmentEnum.TransactionDT]: moment().format(DATE_FORMAT_FOR_UI),
          [AdjustmentEnum.Comments]: '',
          [FilterEnum.GroupId_Bid]: 0,
          [FilterEnum.GroupId_Item]: 0,
          [AdjustmentEnum.AdjustmentItemsInfo]: [],
          [AdjustmentEnum.TransactionId]: TransactionId,
        };
      }
    } else {
      render = true;
      initialValues = {
        [AdjustmentEnum.Site]: GenericEnum.EmptyString,
        [AdjustmentEnum.TransactionDT]: moment().format(DATE_FORMAT_FOR_UI),
        [AdjustmentEnum.Comments]: '',
        [FilterEnum.GroupId_Bid]: 0,
        [FilterEnum.GroupId_Item]: 0,
        [AdjustmentEnum.AdjustmentItemsInfo]: [],
        [AdjustmentEnum.TransactionId]: TransactionId,
      };
    }
    if (render) {
      page === 1
        ? element.push(
            <CreateEditAdjustment
              key={`newEdit${page}`}
              initialValues={initialValues}
              IsNewEdit={IsNewEdit}
              isDisabled={isDisabled}
              fetchingAdjustmentItems={fetchingAdjustmentItems}
              TransactionId={TransactionId}
              showNotificationModal={showNotificationModal}
              hideNotificationModal={this.hideNotificationModal}
              message={message}
              resetPageOnDataChange={this.state.resetPageOnDataChange}
              onResetPageOnDataChange={this.onResetPageOnDataChange}
            />
          )
        : element.push(
            <PreviewAdjustment
              key={`preview${page}`}
              previousPage={this.previousPage}
              initialValues={initialValues}
              onSubmit={this.handleSubmit}
              IsNewEdit={IsNewEdit}
              TransactionId={TransactionId}
              adjustmentItemsInfo={adjustmentItemsInfo}
              resetPageOnDataChange={this.state.resetPageOnDataChange}
              onResetPageOnDataChange={this.onResetPageOnDataChange}
            />
          );
    }
    return element;
  };
  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };

  render() {
    const {
      isReadOnly,
      loading,
      fetchingDropDown,
      submitting,
      fetchingSites,
    } = this.props;
    return fetchingDropDown || loading || submitting || fetchingSites ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={''} breadcrumbs={this.getBreadCrumbs()} />
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              {this.getCreatePageAndPreviewPage()}
            </Main>
          )}
        </DirtyWrapper>
        <YesNoDialog
          showDialog={this.state.showDateModal}
          title={'Future Date Selected'}
          question={'Future adjustment date entered, are you sure Y/N?'}
          yesCallback={() => {
            this.handleDateChange(true);
          }}
          noCallback={() => {
            this.handleDateChange(false);
          }}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_ADJUSTMENT_FORM_NAME);
const mapStateToProps = (state, props) => {
  const { IsNewEdit } = props.match.params;
  const isDisabled =
    CreateEditSelectors.getSelectedAdjustmentDetail(state) &&
    IsNewEdit === NewEditAdjustmentEnum.VIEW;

  return {
    Site: selector(state, [AdjustmentEnum.Site]),
    adjustmentDT: selector(state, [AdjustmentEnum.TransactionDT]),
    adjustmentItemsInfo: selector(state, [AdjustmentEnum.AdjustmentItemsInfo]),

    allTableStates: getTableStates(state),
    isDisabled: isDisabled,
    fetchingSites: AdjustmentSelectors.getFetchingSites(state),

    fetchingAdjustmentItems: CreateEditSelectors.getFetchingAdjustmentItems(
      state
    ),
    adjustmentItemsLoadingError: CreateEditSelectors.getAdjustmentItemsLoadingError(
      state
    ),
    submitting: CreateEditSelectors.getSubmitting(state),
    submitted: CreateEditSelectors.getSubmitted(state),
    submitError: CreateEditSelectors.getSubmitError(state),
    loading: CreateEditSelectors.getLoading(state),
    fetchingDropDown: CreateEditSelectors.getLoading(state),
    fetchingAdjustmentDetail: CreateEditSelectors.getFetchingAdjustmentDetail(
      state
    ),
    selectedAdjustmentDetail: CreateEditSelectors.getSelectedAdjustmentDetail(
      state
    ),
    fetchAdjustmentDetailError: CreateEditSelectors.getFetchAdjustmentDetailError(
      state
    ),

    bidGroupDataError: FilterSelectors.getBidGroupDataError(state),
    itemGroupDataError: FilterSelectors.getItemGroupDataError(state),
  };
};
const mapDispatchToProps = {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAdjustmentItems,
  clearOrderSubmitError,
  clearInvalidPreviewData,
  resetFilterOnClickOfPreviousPage,
  saveAdjustment,
  submitForm,
  resetForm,
  destroyForm,
  getAdjustmentDetail,
  emptyItemList,
  setTableStates,
  emptyEditDulObject,
  resetDirty,
};
export const CreateAdjustmentWizardForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditAdjustmentWizardForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/containers/subpages/CreateEditAdjustmentWizardForm.js